// extracted by mini-css-extract-plugin
export default {"root":"FilterLabel__root--3MBfi","icon":"FilterLabel__icon--2BPOf","text":"FilterLabel__text--cTNfA","cancel":"FilterLabel__cancel--3umL2"};